var _defs, _g, _path, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdatedLogoA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 6512.12 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#FINAL_GRADIENT-2);}.cls-2{fill:#0316a1;}.cls-3{fill:url(#FINAL_GRADIENT);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "FINAL_GRADIENT",
    x1: 3998.22,
    y1: 450,
    x2: 6264.98,
    y2: 450,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#67c84d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#5fc261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#4db295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2f99e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2793ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#825af0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9d56ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e24ce2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e34cd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e74cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ea4ca2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f74666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#f44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ff6c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ffb200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "FINAL_GRADIENT-2",
    x1: 0,
    y1: 450,
    x2: 966.76,
    y2: 450,
    xlinkHref: "#FINAL_GRADIENT"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1155.43,205.59h69.83v428.07h264.66v60.75h-334.5V205.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1570.23,205.59h69.83v488.83h-69.83V205.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1742.01,638.55l25.84-54.47c36.31,32.82,98.46,56.56,161.31,56.56,84.5,0,120.81-32.82,120.81-75.42,0-119.41-296.09-43.99-296.09-225.56,0-75.42,58.66-139.67,187.15-139.67,57.26,0,116.62,15.36,157.12,43.3l-23.05,55.87c-42.6-27.23-90.78-39.8-134.08-39.8-83.1,0-118.71,34.92-118.71,77.51,0,119.41,296.09,44.69,296.09,224.16,0,74.72-60.06,138.97-189.25,138.97-74.72,0-148.05-25.14-187.15-61.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2310.44,266.34h-167.6v-60.75h404.33v60.75h-167.6v428.07h-69.13V266.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2623.28,205.59h69.83v488.83h-69.83V205.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3260.14,205.59v488.83h-57.26l-293.3-364.52v364.52h-69.83V205.59h57.26l293.3,364.52V205.59h69.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3745.47,447.21h67.04v190.64c-48.88,41.2-116.62,62.15-185.06,62.15-150.14,0-260.47-105.45-260.47-250s110.33-250,261.87-250c77.51,0,143.16,25.84,187.85,75.42l-43.3,43.3c-40.5-39.11-86.59-56.56-141.76-56.56-113.13,0-194.83,78.91-194.83,187.85s81.7,187.85,194.13,187.85c41.2,0,79.61-9.08,114.53-31.42v-159.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4190.29,216.59h-192.06v466.82h86.7v-134.71h105.37c122.71,0,198.73-63.35,198.73-166.05s-76.02-166.06-198.73-166.06Zm-4,258.75h-101.37v-185.39h101.37c76.02,0,115.37,34.01,115.37,92.7s-39.35,92.7-115.37,92.7Zm410.14-258.75l-210.07,466.82h89.36l46.02-108.04h233.41l46.68,108.04h90.7l-210.74-466.82h-85.36Zm-45.35,290.76l87.36-204.07,88.03,204.07h-175.39Zm791.6-124.71c0-103.37-76.03-166.06-198.73-166.06h-192.06v466.82h86.7v-136.04h105.37c6,0,12,0,18.01-.67l95.37,136.71h93.36l-107.37-153.38c63.36-24.68,99.37-76.69,99.37-147.38Zm-202.73,93.37h-101.37v-186.06h101.37c76.03,0,115.37,34.01,115.37,92.7s-39.35,93.37-115.37,93.37Zm232.74-259.42h396.13v73.36h-154.72v393.46h-86.7V289.95h-154.72v-73.36Zm892.3,0l-182.73,302.1v164.72h-86.7v-163.39l-183.39-303.43h92.7l136.71,227.41,138.05-227.41h85.36Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M966.66,380.88c-1.33-34.61-15.98-66.71-41.25-90.4L645.32,34.07l-.08-.07C618.92,10.43,584.99-1.58,549.72,.17c-35.28,1.74-67.85,17.04-91.66,43.02l-237.09,254.35c-20.01-9.39-42.62-12.64-64.52-9.16-24.5,3.9-47.24,16.1-64,34.31l-62.97,67.5c-41.51,44.75-38.87,114.92,5.87,156.42l243.57,221.39c21.71,19.38,49.21,29.19,76.79,29.19,21.73,0,43.51-6.09,62.53-18.39l106.48,95.5c18.88,16.68,42.81,25.72,67.86,25.71,1.63,0,3.26-.04,4.89-.11,26.8-1.26,51.68-12.73,70.06-32.32l75.49-81.02c18.26-19.29,28.06-45.56,26.9-72.09-.21-17.34-4.87-34.12-13.55-48.98l176.12-191.29c23.37-25.56,35.5-58.7,34.16-93.31Zm-319.91,17.69c.05,4.52-1.54,8.89-4.46,12.33l-259.1,270.16-16.3,16.3c-6.85,5.84-17.03,5.8-23.82-.14L101.84,477.6c-5.05-5.97-4.95-14.76,.29-20.62l60.22-69.26c6.56-6.13,16.63-6.05,23.09,.25l164.05,148.24,200.99-208.28c7.26-7.06,18.99-7.04,26.22,.08l65.18,59.63c2.63,2.44,4.39,5.72,4.97,9.26l-.12,.53v1.14Zm66.51,70.26c20.29-20.76,31.83-48.17,32.5-77.19v-.45s-.02-.45-.02-.45c-1.99-29.5-15.1-56.72-36.93-76.66l-66.94-62.41-.12-.11c-22.43-20.25-51.41-30.71-81.6-29.47-30.19,1.25-58.21,14.06-78.87,36.06l-136.24,143.91-48.42-44.93,231.26-249.84c14.64-14.13,37.49-15.17,53.35-2.42l279.29,254.63c7.11,6.46,11.32,15.31,11.86,24.93,.56,9.67-2.89,19.29-9.46,26.4l-238.52,259.26,49,43.69c1.92,2.2,1.85,5.49-.19,7.62l-75.34,81.37c-2.76,2.32-6.76,2.25-9.45-.21l-102.32-93.87,227.15-239.86Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6342.11,230.08h-33.59v-12.18h81.04v12.18h-33.59v85.8h-13.86v-85.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6495.64,315.87l-.14-71.38-35.41,59.48h-6.44l-35.41-59.06v70.96h-13.44v-97.97h11.48l40.87,68.86,40.31-68.86h11.48l.14,97.97h-13.44Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedLogoA);
export default __webpack_public_path__ + "static/media/updatedLogoA.5e7328f1b82c888a94a59c2a4d67c9fb.svg";
export { ForwardRef as ReactComponent };